/** Operator selectors enumerate public works; reader pages use bounded cursors. */
export async function listHomepageWorks(api) {
  const items = []
  let cursor
  do {
    const page = await api.visualGame.catalog({ limit: 50, sort: 'featured', cursor })
    items.push(...page.items)
    cursor = page.next_cursor
  } while (cursor)
  return items
}
